import React, { useEffect, useState } from 'react';
import { Alert, Button, Result, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const PendingApproval: React.FC = () => {
  const navigate = useNavigate();
  const [state, setState] = useState<Awaited<ReturnType<typeof authAPI.accessState>> | null>(null);
  useEffect(() => { authAPI.accessState().then(setState).catch(() => undefined); }, []);
  if (!state) return <Spin style={{ display: 'block', margin: '20vh auto' }} />;
  const rejected = state.membership_status === 'rejected';
  const request = rejected ? state.rejected_join_requests?.[0] : state.pending_join_requests?.[0];
  return (
    <Result
      status="info"
      title={rejected ? '机构加入申请未通过' : '等待机构审批'}
      subTitle={rejected
        ? '当前机构未批准您的加入申请；如需继续使用，请联系机构管理员重新发起邀请。'
        : '账号已验证，但是加入机构的申请尚未批准。批准后即可进入工作台。'}
      extra={(
        <>
          {request?.review_note ? <Alert type="warning" showIcon message={`审核备注：${request.review_note}`} style={{ marginBottom: 12, textAlign: 'left' }} /> : null}
          <Button type="primary" onClick={() => navigate('/login')}>返回登录</Button>
        </>
      )}
    />
  );
};

export default PendingApproval;
